<button [nzSize]="'small'" nz-button nzType="default">
  <label for="file" class="d-inline-block">
    <i nz-icon nzIconfont="icon_upload"></i>
    添加图片
    <!-- <span class="character">添加图片</span> -->
  </label>
</button>
<input type="file" class="file d-none" (change)="selectFile($event, 1)" id="file" />
<!--<button [nzSize]="'small'" nz-button nzType="default">-->
<!--  <label for="file" class="d-inline-block">-->
<!--    <i nz-icon nzIconfont="icon_upload"></i>-->
<!--    添加视频-->
<!--    &lt;!&ndash; <span class="character">添加图片</span> &ndash;&gt;-->
<!--  </label>-->
<!--</button>-->
<!--<input type="file" class="file d-none" (change)="selectFile($event, 2)" id="file-video" />-->
<app-global-loading *ngIf="isVisibleMiddle"></app-global-loading>
<!-- <label for="file" class="uploading d-inline-block">
  <i style="font-size: 28px" nz-icon nzType="plus" nzTheme="outline"></i>
  <span class="character">添加图片</span>
</label> -->
